import React from 'react';
import { useTranslation } from 'react-i18next';

import { SITE_LINKS } from '../constants';
import Tab from '../stories/Tab';
import { TabItemProps } from '../stories/TabItem';

interface ProgressTabProps {
  activeKey: string;
}

const ProgressTab = (props: ProgressTabProps) => {
  const __ = useTranslation().t;
  const tabItems: TabItemProps[] = [
    {
      href: SITE_LINKS.LiveClassHistoryPage,
      position: 'left',
      title: __('liveClassHistory'),
    },
    {
      href: SITE_LINKS.LessonIndexPage,
      position: 'right',
      title: __('lessonIndex'),
    },
  ];

  return <Tab activeKey={props.activeKey} items={tabItems} />;
};

export default ProgressTab;
